<template>
    <p v-if="hasLastActivityText" class="mt-3">
        Last updated {{ agency.last_activity_text }}
    </p>
</template>

<script>
export default {
  name: 'AgencyAdvertLastUpdate',
  components: {
  },
  props: {
    agency: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    hasLastActivityText() {
        return (
            typeof(this.agency.last_activity_text) != 'undefined' 
            && this.agency.last_activity_text !== null
        );
    },
  }
}
</script>
